import type { Currency, NewProduct, NewPromotion, Product, ProductInput, Promotion, PromotionInput } from '@weft/types';
import { isNullOrUndefined, raise } from '@weft/utils';
import { once } from 'lodash';
import { createContext, useContext } from 'react';

type ItemType = Product | ProductInput | NewProduct | Promotion | PromotionInput | NewPromotion;

type ChargeContextProps<Item extends ItemType> = {
  item: Item;
  itemIndex: number;
  editable: boolean;
  currency: Currency;
};

const createChargeContext = once(<Item extends ItemType>() => createContext<ChargeContextProps<Item> | undefined>(undefined));

export function ChargeProvider<Item extends ItemType>({ children, value }: { children: React.ReactNode; value: ChargeContextProps<Item> }) {
  const ChargeContext = createChargeContext<Item>();

  return (
    <ChargeContext.Provider value={value}>
      {children}
    </ChargeContext.Provider>
  );
}

export function useChargeContext<Item extends ItemType>() {
  const context = useContext(createChargeContext<Item>());

  if (isNullOrUndefined(context)) {
    raise('useChargeContext must be used within a ChargeProvider');
  }

  return context;
}